import { AddonPurchaseHost } from '@/features/billing';
import { useOpenFlexPricing } from '../hooks/use-open-flex-pricing';

export function AddonPurchaseHostWithPricing() {
  return <AddonPurchaseHost onLearnMorePricing={useOpenFlexPricing()} />;
}
